import { modelOptions, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, SchemaBase, getDefaultSchemaOptions, SchemaConstructorArgs } from "../../schemaBase.js";
import { Gen4ValveInternalState } from "./gen4ValveInternalState.js";
const SCHEMA_KEY = "Gen4ValveSubsystemStates" as const;

/**
 * For some reason, typescript cannot recognize the numeric versions of these keys when they show up in update paths
 * unless this is an array type. Since the dataIDs are numeric, it makes sense for the keys of this to just be those dataIDs.
 * I would (and originally did) reference them with keys like `[DataIDs.INACTIVE]` but this was not acceptable to Typescript.
 *
 * Just making this an array was my first choice, but mongo can't unset an element of an array and it was going to
 * require a lot of go around in a lot of different places to fix the problem, and anyone adding a new uplink/downlink
 * that touched sensors would need to be aware of this strange behaviour.
 *
 * This solution was chosen because, even though it is fucking strange, the strange is confined to this file alone.
 * The type output, model output, and JS output of this file are all completely normal. All object keys are string
 * serialized in JS anyway, so the key `["0"]` is directly equivalent to `0`. It's just a pre-compile bug (possibly in TS)
 * that causes `0` to break the update path typings.
 */
@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<Gen4ValveSubsystemsStates>>(...addSchemaKeyHook(SCHEMA_KEY))
export class Gen4ValveSubsystemsStates extends SchemaBase<Gen4ValveSubsystemsStates> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Gen4ValveInternalState, required: false })
    ["0"]?: Gen4ValveInternalState;

    static getters = {} as const satisfies Record<string, (self: Gen4ValveSubsystemsStates) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<Gen4ValveSubsystemsStates>) {
        super(properties);
        Object.assign(this, properties);
    }
}
